module.exports = __webpack_public_path__ + "img/sol_isol_pain3.b8b9eb7d.png";